import { getContext, Symbols } from 'choerodon-ui/shared';
import translateDOMPositionXY from './utils/translateDOMPositionXY';
import isRTL from './utils/isRTL';
const TableContext = getContext(Symbols.ProPerformanceTableContext, {
    rtl: isRTL(),
    hasCustomTreeCol: false,
    isTree: false,
    translateDOMPositionXY,
    tableStore: {},
});
export default TableContext;
